<template>
  <div class="main-container">
    <!-- Start of breadcrumb -->
    <breadcrumb
      main_step_name="Payroll"
      sub_step_name="Utilities"
      step_name="Delete Payroll data"
      @goToMainStep="routeToMainStep"
      @goToSubStep="routeToSubStep"
    ></breadcrumb>
    <!-- End of breadcrumb -->

    <!-- Start of header -->

    <tl-header type="h1">
      <div class="main-header margintop-30">Delete Payroll data</div>
    </tl-header>

    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>

    <!-- End of header -->
    <!-- Start of contents -->
    <div :disabled="!ifTeamleaderAnchorPermission">
      <div class="row margintop-10">
        <div class="col-3">
          <tl-select label="Select month" :options="monthList"></tl-select>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <tl-select label="Select paygroup" :options="payGroupList"></tl-select>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <btn text="Delete Paygroup" type="secondary" @click="deletePayroll" />
        </div>
      </div>
    </div>
    <!-- End of Contents -->
    <!-- details for deletion of payroll -->

    <div class="modal custom-modal" v-if="showModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Log in again to Continue</h3>
        </div>
        <div class="modal-body">
          <div class="row body-padding">
            <div class="col-12 text-center text-message">
              Enter your below details to continue delete
              Payroll Data
            </div>
            <div class="col-12 margintop-20">
              <txt
                label="Email ID/ Mobile Number"
                name="email_mobile"
                placeholder="Email ID / Mobile Number"
              />
            </div>
            <div class="col-12 margintop-10">
              <txt type="password" label="Password" name="password" />
            </div>
          </div>
          <div class="row margintop-10 marginbot-20">
            <div class="col-12">
              <btn text="Log in" type="primary" class="login-btn" v-on:click="logInToDelete()"></btn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end -->
    <pop-up-message
      v-if="showPopup"
      popupType="Warning"
      :message="popupMessage"
      popupHeaderMessage="Warning"
      btnText="Ok"
      @back="goBack()"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group" v-if="!isLogInConfirmed">
          <button class="btn-popup-secondary" type="button" @click="goBack()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmDeletion()">Yes</button>
        </div>
        <div v-if="isLogInConfirmed" class="margintop-20">
          <txt label="Enter Description *" type="textarea" />
          <span class="mandatory-field">* this field is mandatory</span>
          <div class="popup-btn-group marginleft-10p margintop-20">
            <button
              class="btn-popup-secondary"
              type="button"
              @click="goBack()"
            >Cancel</button>
            <button class="btn-popup" type="button" @click="deleteFinally()">Delete</button>
          </div>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      v-if="showSuccessMessage"
      message="Payroll Data for 'August' Month has been succesfully deleted."
      btnText="back"
      @back="backToPage"
    ></pop-up-message>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "DeletePayrollData",
  data() {
    return {
      showModal: false,
      showPopup: false,
      isLogInConfirmed: false,
      showSuccessMessage: false,
      popupMessage:
        'Are you sure yoy want to delete Payroll Data for "August" Month?',
        monthList:[
            {
                label:'January',
                value:'jan'
            },
            {
                label:'February',
                value:'feb'
            },
            {
                label:'March',
                value:'mar'
            },
            {
                label:'April',
                value:'apr'
            }
        ],
        payGroupList:["Paygroup1", "Paygroup 2"],
        deletePayrollDataValue: false,
        role: ""
    };
  },
  mounted() {
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.deletePayrollDataValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    routeToMainStep() {},
    routeToSubStep() {},
    deletePayroll() {
      this.showPopup = true;
    },
    goBack() {
      this.showPopup = false;
      this.isLogInConfirmed = false;
    },
    confirmDeletion() {
      this.showPopup = false;
      this.showModal = true;
    },
    logInToDelete() {
      this.showModal = false;
      this.showPopup = true;
      this.popupMessage =
        "Brief Description is Required to Delete payroll Data";
      this.isLogInConfirmed = true;
    },
    deleteFinally() {
      this.showPopup = false;
      this.showSuccessMessage = true;
    },
    backToPage() {
      this.showSuccessMessage = false;
    },

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.deletePayrollDataValue = data.data.user.permissions.delete_payroll_data ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
.login-btn {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.body-padding {
  padding: 20px 60px;
  margin-left: 0px;
}
.text-message {
  color: #6e6e6e;
  font-size: 16px;
}
.mandatory-field {
  font-size: 10px;
  font-weight: normal;
  font-style: italic;
  color: rgba(0, 0, 0, 0.25);
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
